import * as THREE from 'three'
import React, { useRef, useMemo } from 'react'
import { useFrame, useThree, useLoader } from 'react-three-fiber'
import './styles.css'
import img from './smoke.png'

export default function Smoke({ count, mouse }) {
  const texture = useLoader(THREE.TextureLoader, img)
  const mesh = useRef()
  const light = useRef()
  const { size, viewport } = useThree()
  const aspect = size.width / viewport.width

  const dummy = useMemo(() => new THREE.Object3D(), [])
  // Generate some random positions, speed factors and timings
  const particles = useMemo(() => {
    const temp = []
    for (let i = 0; i < count; i++) {
      const t = Math.random() * 100
      const factor = 100 + Math.random() * 100
      const speed = 0.0005 + Math.random() / 200
      const xFactor = -50 + Math.random() * 100
      const yFactor = -50 + Math.random() * 100
      const zFactor = -200 + Math.random() * 100
      temp.push({ t, factor, speed, xFactor, yFactor, zFactor, mx: 0, my: 0 })
    }
    return temp
  }, [count])
  // The innards of this hook will run every frame
  useFrame((state) => {
    // Makes the light follow the mouse
    light.current.position.set(mouse.current[0] / aspect, -mouse.current[1] / aspect, 0)
    // Run through the randomized data to calculate some movement
    particles.forEach((particle, i) => {
      let { t, factor, speed, xFactor, yFactor, zFactor } = particle
      // There is no sense or reason to any of this, just messing around with trigonometric functions
      t = particle.t += speed / 2
      const a = Math.cos(t) + Math.sin(t * 1) / 10
      const b = Math.sin(t) + Math.cos(t * 2) / 10
      const s = Math.cos(t) * 1
      particle.mx += (mouse.current[0] - particle.mx) * 0.05
      particle.my += (mouse.current[1] * -1 - particle.my) * 0.05
      // Update the dummy object
      dummy.position.set(
        (particle.mx / 10) * a + xFactor + Math.cos((t / 10) * factor) + (Math.sin(t * 1) * factor) / 1,
        (particle.my / 20) * b + yFactor + Math.sin((t / 20) * factor) + (Math.cos(t * 2) * factor) / 11,
        (particle.my / 20) * b + zFactor + Math.cos((t / 10) * factor) + (Math.sin(t * 3) * factor) / 9
      )
      dummy.scale.set(s, s, s)
      dummy.rotation.set(s * 5, s * 5, s * 5)
      dummy.updateMatrix()
      // And apply the matrix to the instanced item
      mesh.current.setMatrixAt(i, dummy.matrix)
    })
    mesh.current.instanceMatrix.needsUpdate = true
  })
  return (
    <>
      <pointLight ref={light} distance={0} intensity={0} color="white"/>
      <pointLight ref={light} distance={0} intensity={3} color="white"/>
      <directionalLight position={0,0,1} intensity={0} color="white"/>
      <instancedMesh ref={mesh} args={[null, null, count]}>
        <sphereBufferGeometry args={[40, 300]} />
        {/* <meshPhongMaterial color="#e9e6f0" /> */}
        <meshLambertMaterial attach="material" map={texture} color="yellow" transparent opacity="0.05"/>
      </instancedMesh>
    </>
  )
}
